import { render, staticRenderFns } from "./FooterFormScreen.vue?vue&type=template&id=1f8c702e&"
import script from "./FooterFormScreen.vue?vue&type=script&lang=ts&"
export * from "./FooterFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports